module.exports = __webpack_public_path__ + "static/media/27.2977d3c5.png";